var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-card"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('h2',{staticClass:"font-medium text-[23px] italic text-center uppercase tracking-widest"},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('MenuItems',{attrs:{"items":item.items}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }